import React from "react";
import type { Placement, ReferenceType } from "@floating-ui/react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  type OpenManagementMode,
} from "./Popover";

export const POPOVER_CONTAINER_CLASS = "seem-popover";

export interface SeemPopoverProps {
  isOpen?: boolean | null;
  setIsOpen?: ((open?: boolean) => void) | null;
  children?: React.ReactNode;
  body?: React.ReactNode;
  placement?: Placement;
  className?: string;
  onOuterAction?: () => void;
  triggerClassName?: string;
  useSameWidth?: boolean;
  triggerFullWidth?: boolean;
  openManagementMode?: OpenManagementMode | null;
  virtualReference?: ReferenceType | null;
  delayOpen?: number;
  delayClose?: number;
  fallbackPlacements?: Placement[];
}

const SeemPopover: React.FC<SeemPopoverProps> = ({
  isOpen,
  setIsOpen = null,
  children,
  body,
  placement,
  className,
  onOuterAction,
  triggerClassName,
  useSameWidth = false,
  triggerFullWidth = false,
  openManagementMode,
  virtualReference = null,
  delayOpen,
  delayClose,
  fallbackPlacements,
}) => {
  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen ?? undefined}
      placement={placement}
      className={className}
      openManagementMode={openManagementMode}
      onOuterAction={onOuterAction}
      useSameWidth={useSameWidth}
      virtualReference={virtualReference}
      delayOpen={delayOpen}
      delayClose={delayClose}
      fallbackPlacements={fallbackPlacements}
    >
      <PopoverTrigger
        className={triggerClassName}
        triggerFullWidth={triggerFullWidth}
        onClick={() => {
          setIsOpen?.();
        }}
        style={triggerFullWidth ? { width: "100%" } : undefined}
      >
        {children}
      </PopoverTrigger>
      {!!body && (
        <PopoverContent className={`${POPOVER_CONTAINER_CLASS} ${className}`}>
          {body}
        </PopoverContent>
      )}
    </Popover>
  );
};

export default SeemPopover;
